import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Popover from '@components/popover';
import Link from '@components/link';

import { useLocalized } from 'utils/useLocalized';
import { helpSiteUrl, mainSiteUrl } from 'urls';
import { viewFeature } from 'utils/requests/enabler';

import i18nStrings from './strings';
import styles from './styles.modules.scss';

const Informer = ({children, locale, description, popoverFeature}) => {
    const strings = useLocalized(i18nStrings);
    const helpUrl = locale === 'en' ? `${helpSiteUrl}/active-carriers-search` : `${helpSiteUrl}/poisk-aktivnykh-perevozchikov`;
    const [visiblePopover, setVisiblePopover] = useState(false);

    useEffect(() => {
        if (popoverFeature)
            setVisiblePopover(!popoverFeature?.isViewed);
    }, [popoverFeature]);

    const handlePopoverCloseClick = () => {
        viewFeature(popoverFeature.id, mainSiteUrl).then(() => {
            setVisiblePopover(false);
            popoverFeature.isViewed = true;
        });
    };

    return (
        <Popover
            isWithoutWrapper
            className={styles['popover']}
            classNames={{closeButton: styles['close-button']}}
            content={(
                <Popover.Content className={styles['content']}>
                    {description}
                    <Link
                        href={helpUrl}
                        target="_blank"
                    >
                        {strings.details}
                    </Link>
                </Popover.Content>
            )}
            isAdaptive={false}
            theme="yellow"
            visible={visiblePopover}
            zIndex={{ tip: 9998 }}
            onCloseClick={handlePopoverCloseClick}
        >
            <span className={styles['children-wrapper']}>
                {children}
            </span>
        </Popover>
    );
};

Informer.propTypes = {
    children: PropTypes.node,
    description: PropTypes.string,
    locale: PropTypes.string,
    popoverFeature: PropTypes.object,
};

export default Informer;